<template>
    <img :src="$page.props.logo_mark">
</template>
